// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bMessageSettingsForm {\n  margin-top: 20px;\n}\n\n.bMessageTextFormSmsEditor,\n.bMessageTextFormPushEditor,\n.bMessageTextFormEmailEditor {\n  margin-top: 10px;\n  padding: 10px;\n}\n\n.eMessageTextFormSmsEditorCounters {\n  margin-top: 20px;\n}\n", ""]);
// Exports
module.exports = exports;
